<template>
  <div class="rank">
    <van-nav-bar title="总榜列表" left-text="返回" left-arrow @click-left="goBack" />
    <!-- <div class="top">
      <div>列表排序：</div>
      <div class="select-area">
        <div class="label">按照实战评定</div>
        <div class="button"></div>
      </div>
    </div> -->
    <div class="list">
      <div @click="searchItem(item)" class="item" v-for="(item, index) in list" :key="index">
        <div class="name">{{ item.name }}</div>
        <div class="s-item">
          <div class="score">{{ item.minstar }}<span>星</span></div>
          <div class="s-name">技术总评</div>
        </div>
        <div class="s-item" v-for="row in items" :key="row.itemid">
          <div class="score">{{ item.scores | showStar(row.itemid) }}<span>星</span></div>
          <div class="s-name">{{ row.itemname }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { judgeRank } from '../../libs/api.js'

export default {
  data() {
    return {
      info: {},
      list: [],
      items: [],
    }
  },
  filters: {
    showStar(list, itemid) {
      const row = list.find((row) => {
        return row.itemid === itemid
      })
      if (row) {
        return row.stars
      } else {
        return '-/-'
      }
    },
  },
  mounted() {
    const info = localStorage.getItem('judge_info')
    this.info = JSON.parse(info)

    this.getList()
  },
  methods: {
    searchItem(item) {
      let num = item.number
      if (!num) num = item.name
      this.$router.replace({ name: 'wuxing_judge', query: Object.assign({}, this.$route.query, { num }) })
    },
    getList() {
      judgeRank({ matchid: this.$route.query.matchid, judgeid: this.info.judgeid, token: this.info.token }).then((r) => {
        this.list = r.data.list
        this.items = r.data.item
      })
    },
    goBack() {
      this.$router.replace({ name: 'wuxing_judge', query: this.$route.query })
    },
  },
}
</script>

<style lang="less" scoped>
.rank {
  .top {
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 15px 15px;
    font-size: 14px;
    .select-area {
      background: #f5f5f5;
      padding: 5px 15px;
      border-radius: 20px;
    }
  }
  .list {
    padding: 20px 15px 40px;
    .item {
      background: #ffffff;
      box-shadow: 0 1px 10px 0 rgba(192, 210, 226, 0.5);
      border-radius: 4px;
      margin-bottom: 8px;
      padding: 12px 15px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .name {
        text-align: center;
        width: 19%;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
      }
      .s-item {
        width: 27%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .score {
          font-size: 20px;
          color: #333;
          display: flex;
          align-items: center;
          font-weight: bold;
          span {
            font-size: 12px;
            margin-left: 4px;
          }
        }
        .s-name {
          font-size: 12px;
          color: #999999;
        }
      }
    }
  }
}
</style>
